module.exports = __webpack_public_path__ + "static/img/baojingjiechu2.8176d47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/baojingjiechu2.png
// module id = eLg8
// module chunks = 24